import { Link } from 'react-router-dom';
import { BookOpen, FileText, Lightbulb } from 'lucide-react';

const ratgeberArticles = [
  {
    title: 'Hausbau in Südtirol',
    description: 'Alles Wichtige zum Bauen in Südtirol: Von Vorschriften über Kosten bis zur Baufirmenauswahl.',
    path: '/ratgeber/hausbau-in-suedtirol',
    icon: FileText
  },
  {
    title: 'Baufirma in Meran finden',
    description: 'Worauf du bei der Auswahl deiner Baufirma achten solltest – ein praktischer Leitfaden.',
    path: '/haus-und-bau/baufirma-meran',
    icon: FileText
  }
];

export default function Ratgeber() {
  return (
    <div className="section-spacing" data-testid="ratgeber-page">
      <div className="container-wide">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <nav className="text-sm text-[#64748B] mb-4" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#0284C7]">Start</Link>
            <span className="mx-2">/</span>
            <span className="text-[#0F172A]">Ratgeber</span>
          </nav>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Ratgeber
          </h1>
          <p className="text-lg text-[#475569]">
            Ausführliche Artikel und Leitfäden zu den wichtigsten Themen 
            rund um Wohnen, Bauen und Immobilien in Südtirol.
          </p>
        </div>

        {/* Info Box */}
        <div className="bg-[#0284C7]/5 border border-[#0284C7]/20 rounded-xl p-6 mb-12 flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-[#0284C7]/10 flex items-center justify-center flex-shrink-0">
            <Lightbulb className="text-[#0284C7]" size={20} />
          </div>
          <div>
            <h3 className="font-semibold text-[#0F172A] mb-1">Evergreen-Wissen</h3>
            <p className="text-sm text-[#475569]">
              Unsere Ratgeber sind so geschrieben, dass sie langfristig relevant bleiben. 
              Grundsätzliche Orientierung statt kurzfristige Trends.
            </p>
          </div>
        </div>

        {/* Articles Grid */}
        <h2 className="text-2xl font-bold text-[#0F172A] mb-6 font-[var(--font-heading)]">
          Alle Ratgeber
        </h2>
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {ratgeberArticles.map((article, index) => {
            const Icon = article.icon;
            return (
              <Link
                key={index}
                to={article.path}
                className="group bg-white rounded-xl p-6 border border-[#E2E8F0] hover:border-[#0284C7]/30 transition-all duration-300 card-hover"
              >
                <div className="w-10 h-10 rounded-lg bg-[#0F172A]/5 flex items-center justify-center mb-4 group-hover:bg-[#0284C7]/10 transition-colors">
                  <Icon className="text-[#0F172A] group-hover:text-[#0284C7] transition-colors" size={20} />
                </div>
                <h3 className="font-semibold text-lg text-[#0F172A] mb-2 group-hover:text-[#0284C7] transition-colors">
                  {article.title}
                </h3>
                <p className="text-[#475569] text-sm">
                  {article.description}
                </p>
              </Link>
            );
          })}
        </div>

        {/* Interactive Content Promo */}
        <div className="bg-[#F8FAFC] rounded-xl p-8 border border-[#E2E8F0]">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-[#F97316]/10 flex items-center justify-center flex-shrink-0">
              <BookOpen className="text-[#F97316]" size={24} />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-[#0F172A] mb-2 font-[var(--font-heading)]">
                Lieber spielerisch lernen?
              </h2>
              <p className="text-[#475569] mb-4">
                Neben unseren Ratgebern bieten wir auch interaktive Tippspiele, 
                Quiz und Entscheidungshelfer. Manchmal ist Learning by Doing 
                der bessere Weg.
              </p>
              <Link 
                to="/tippspiele"
                className="inline-flex items-center gap-2 text-[#F97316] font-medium hover:underline"
              >
                Zu den Tippspielen →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
